export default __webpack_public_path__ + "static/media/ultima_milla_telematica_mini.62467009.jpg";